import { useMutation, useQueryClient } from '@tanstack/react-query';
import { menuApi } from '../api/menuApi';
import type { UpdateMenuRequest } from '../types/menu';

/**
 * PATCH /api/eraf/menus/{id} — 메뉴 수정
 * 성공 시 tree / flat / detail 캐시 무효화
 */
export function useUpdateMenu() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: UpdateMenuRequest }) =>
      menuApi.update(id, body),
    onSuccess: (_data, variables) => {
      void qc.invalidateQueries({ queryKey: ['menu-management', 'tree'] });
      void qc.invalidateQueries({ queryKey: ['menu-management', 'flat'] });
      void qc.invalidateQueries({ queryKey: ['menu-management', 'detail', variables.id] });
      void qc.invalidateQueries({ queryKey: ['menu-management', 'me'] });
      void qc.invalidateQueries({ queryKey: ['catalog'] });
    },
  });
}
